var Associated = {
    load: function(url, container) {
        container.empty();
        Framework7.request.get(
            url + '?action=associated', 
            function (data) {
                container.html(data);
                app.lazy.create(container) 
            }
        )
    }
};